import { render, staticRenderFns } from "./IncomeTax.vue?vue&type=template&id=64054350&"
import script from "./IncomeTax.vue?vue&type=script&lang=js&"
export * from "./IncomeTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports